/* Greenfield homepage sections (gf-home-*) — hero intro, scroll reveal, deal countdown, quick add.
   Loaded by every gf-home-* section; runs once. */
(function () {
  if (window.__gfHome) return;
  window.__gfHome = true;

  if (window.Shopify && window.Shopify.designMode) {
    document.documentElement.classList.add('gf-design');
  }

  /* hero load animation */
  function heroIntro(scope) {
    (scope || document).querySelectorAll('.hero h1 [data-w]').forEach(function (el, i) {
      if (el.dataset.gfIn) return;
      el.dataset.gfIn = '1';
      el.style.transition = 'transform .9s cubic-bezier(.16,1,.3,1)';
      el.style.transitionDelay = (0.12 + i * 0.11) + 's';
      requestAnimationFrame(function () { el.style.transform = 'translateY(0)'; });
    });
  }

  /* scroll reveal */
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' })
    : null;

  function reveal(scope) {
    (scope || document).querySelectorAll('.reveal:not(.in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('in');
    });
  }

  /* countdown to the next Philippine midnight (00:00 UTC+8) — same for every visitor */
  var DAY = 864e5, PH = 288e5;
  function nextPhMidnight() { var now = Date.now(); return now + (DAY - (now + PH) % DAY); }
  function pad(n) { return String(n).padStart(2, '0'); }

  function countdown(scope) {
    (scope || document).querySelectorAll('[data-gf-countdown]').forEach(function (cd) {
      if (cd.dataset.gfTick) return;
      cd.dataset.gfTick = '1';
      var end = nextPhMidnight();
      var h = cd.querySelector('[data-h]'), m = cd.querySelector('[data-m]'), s = cd.querySelector('[data-s]');
      var timer;
      function tick() {
        if (!cd.isConnected) { clearInterval(timer); return; }
        var d = end - Date.now();
        if (d <= 0) { end = nextPhMidnight(); d = end - Date.now(); }
        h.textContent = pad(Math.floor(d / 3.6e6));
        m.textContent = pad(Math.floor(d % 3.6e6 / 6e4));
        s.textContent = pad(Math.floor(d % 6e4 / 1e3));
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  }

  /* cart: real Shopify cart + Horizon cart drawer */
  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') drawer.open();
    else window.location.href = '/cart';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gf-home] [data-gf-add]');
    if (!btn) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.classList.contains('gf-loading')) return;

    btn.classList.add('gf-loading');
    btn.setAttribute('aria-busy', 'true');

    var payload = { items: [{ id: Number(variantId), quantity: 1 }] };
    var sections = cartSectionIds();
    if (sections.length) payload.sections = sections.join(',');

    var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          var msg = res.data.description || res.data.message || 'Sorry, this item is no longer available.';
          document.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { data: { message: msg } } }));
          return;
        }
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'gf-home', data: { source: 'gf-home', sections: res.data.sections } }
          }));
          openCartDrawer();
        });
      })
      .catch(function () {
        if (window.gfToast) window.gfToast('Something went wrong. Please try again.', { type: 'error' });
      })
      .finally(function () {
        btn.classList.remove('gf-loading');
        btn.removeAttribute('aria-busy');
      });
  });

  function init(scope) { reveal(scope); countdown(scope); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  if (document.readyState === 'complete') heroIntro();
  else window.addEventListener('load', function () { heroIntro(); });

  /* theme editor re-renders a section → wire up the new markup */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    heroIntro(e.target);
  });
})();
